import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";

const MultiSelect = ({ placeholder, options, name, selected, onChange }) => {
  const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  };

  const [selectedOption, setSelectedOption] = useState(selected);

  const prevOptions = usePrevious(options);
  const prevSelected = usePrevious(selected);

  useEffect(() => {
    if (prevOptions !== options || prevSelected !== selected) {
      setSelectedOption(selected);
    }
  }, [prevOptions, prevSelected, selected, options]);

  const handleSelection = (selectedOption) => {
    setSelectedOption(selectedOption);
    onChange(selectedOption, name);
  };

  return (
    <Select
      name={name}
      onChange={handleSelection}
      options={options}
      placeholder={placeholder}
      value={selectedOption}
      isMulti={true}
      isSearchable={true}
    />
  );
};

export default MultiSelect;
